import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectHomeStatus } from '../redux/selectors';
import { searchParametersSlice } from '../redux/slices';
import SpecStatus from '../enums/specStatus';
import ProductType from '../enums/productType';
import ResultType from '../enums/resultType';
import { hasModelHome } from '../services/homeStatusValidator';

export default class ModelHomeHousingType {
  constructor() {
    this.selector = '[data-housing-type="modelHomes"]';
    this.productType = ProductType.Homes.toString();
    this.resultType = ResultType.Homes.toString();

    store$.pipe(map(selectHomeStatus), distinctUntilChanged()).subscribe(this.onModelHomesChange.bind(this));
  }

  /**
   * The dispatchAction function dispatches a fetchModelHome action with the payload obtained from the
   * getSearchCommands function.
   */
  dispatchFetchResultAction() {
    const payload = this.getSearchCommands();
    store.dispatch(searchParametersSlice.actions.fetchModelHome(payload));
  }

   /**
   * Gets the node element of Model Home Housing Type.
   * @returns {Node} element.
   */
   getNode() {
    return document.querySelector(this.selector);
  }

  /**
   * getSearchCommands: Gets the search command property of this Housing Type.
   * @returns The search command property string.
   */
  getSearchCommands() {
    const searchCommandPropertyStructure = {
      homeStatus: SpecStatus.Model.toString(),
      productType: this.productType,
      resultType: this.resultType,
    };

    return searchCommandPropertyStructure;
  }

    /**
   * The function select the option based on the value of the model home parameter.
   * @param homeStatus - The modelHomes parameter is a string value that represents
   * the current home status selected from the store.
   */
    onModelHomesChange(homeStatus) {
        this.toggleSelect(homeStatus);
      }
    
      /**
       * The select function adds or removes the 'active' class from a node based on the value of the
       * modelHomes property.
       */
      toggleSelect(homeStatus) {
        const node = this.getNode();
        if (hasModelHome(homeStatus)) {
          node.selected = true;
        } else {
          node.selected = false;
        }
      }
}
